import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { useErrorReport } from "./processingDiscoveryServices";
import Container from "@material-ui/core/Container";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { capitalCase } from "change-case";
import { map, pipe, toPairs } from "ramda";
import { List, ListItem, ListItemText } from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const formatErrors = pipe(
  toPairs,
  map(([key, value]) => `${capitalCase(key)} ${value}`),
);

const ContentIngestionErrorsDialog = ({ errorFileLocation, open, onClose }) => {
  const {
    data: errorReport,
    isLoading: isLoading,
    isSuccess: isSuccess,
  } = useErrorReport(errorFileLocation);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      aria-labelledby="Error Report"
    >
      <DialogTitle id="content-ingestion-error-dialog-title">
        Error Report
      </DialogTitle>
      <DialogContent>
        {isLoading && (
          <Container style={{ height: 400 }}>
            <PanelLoadingIndicator />
          </Container>
        )}

        {isSuccess && (
          <List>
            {map(
              error => (
                <ListItem>
                  <ListItemIcon>
                    <ErrorOutlineIcon fontSize="large" color="error" />
                  </ListItemIcon>
                  <ListItemText primary={error} />
                </ListItem>
              ),
              formatErrors(errorReport),
            )}
          </List>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentIngestionErrorsDialog;
